import React, { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useVerifyIsMobile } from './../../../../../../hooks/useVerifyIsMobile';
import { getFilterOptions } from '../../utils/calendarUtils';
import { translate } from './../../../../utils/mundialUtils';
//------------------------------------------------------------------------
import CustomSelect from './../../../../../../components/CustomSelect';
import './style.scss';
import MobileSelectModal from 'components/MobileSelectModal';

export const RoundFilter = ({ selected, changeFilter, translations }) => {
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const { structure } = useSelector(state => state.Mundial.Calendar);
  const { isMobile } = useVerifyIsMobile();

  const handleSelectClick = (e, id) => {
    e.preventDefault();
    changeFilter(prev => ({
      textContent: e.target.textContent,
      id,
      prevFilter: { textContent: prev.textContent, id: prev.id },
    }));
    setShowMobileFilter(false);
  };

  const getOptions = useCallback(
    () => {
      if (structure.length === 0) return;
      return (
        <Fragment>
          <li
            key="today"
            onClick={e => handleSelectClick(e, 'today')}
            className={`${selected.id === 'today' ? 'selected' : 'unselected'}`}
          >
            {translate('calendar_phases_option_item_today', translations)}
          </li>
          {getFilterOptions(structure).map((option, i) => (
            <li
              key={`${option.id}${i}`}
              className={`${
                option.id === selected.id ? 'selected' : 'unselected'
              }`}
              onClick={e => handleSelectClick(e, option.id)}
            >
              {option.names.default}
            </li>
          ))}
          <li
            onClick={e => handleSelectClick(e, 'all')}
            className={`${selected.id === 'all' ? 'selected' : 'unselected'}`}
          >
            {translate('calendar_phases_option_item_all', translations)}
          </li>
        </Fragment>
      );
    },
    [structure, selected],
  );

  if (structure.length === 0) return null;

  return (
    <div className="round-filter">
      {isMobile ? (
        <MobileSelectModal
          selected={selected?.textContent}
          show={showMobileFilter}
          setShow={setShowMobileFilter}
        >
          {getOptions()}
        </MobileSelectModal>
      ) : (
        <CustomSelect selected={selected?.textContent}>
          {getOptions()}
        </CustomSelect>
      )}
    </div>
  );
};
